import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing } from 'ui/theme';
import { ModalSize } from './Modal.constants';
import { FooterMessageContainer, MODAL_FOOTER_STYLES } from './Modal.styled';
import { useModalContext } from './ModalContext';
import { DataSet, ModalFooterProps } from './types';

type StyledActionsProps = {
  hasCancel: boolean;
  size?: ModalSize;
};
const StyledActions = styled.div<StyledActionsProps>`
  display: flex;
  flex: 0 0 auto;
  gap: ${spacing.half};
  justify-content: flex-end;
  padding: ${spacing.threeQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
  border-radius: 0 0 ${spacing.threeQuarter} ${spacing.threeQuarter};

  &[data-has-message='true'] {
    justify-content: space-between;
  }

  ${({ size }) => (size && MODAL_FOOTER_STYLES[size]) || ``};
`;

const PrimaryActions = styled.div`
  display: flex;
  column-gap: ${spacing.half};
`;

export const ModalFooter = ({
  children,
  hasCancel = true,
  cancelLabel = 'Cancel',
  onClose: onCloseProp,
  size: sizeProp,
  message = '',
  ...props
}: ModalFooterProps) => {
  const { onClose: onCloseContext, size: sizeContext } = useModalContext();
  const onClose = onCloseProp ?? onCloseContext;
  const size = sizeProp ?? sizeContext;

  return (
    <StyledActions
      hasCancel={hasCancel}
      size={size}
      onClick={(e) => e.stopPropagation()}
      data-test={DataSet.ModalFooterTestId}
      data-has-message={!!message}
      {...props}
    >
      {message && <FooterMessageContainer>{message}</FooterMessageContainer>}
      <PrimaryActions>
        {hasCancel && (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            size={BUTTON_SIZES.LARGE}
            variant={BUTTON_VARIANTS.GHOST}
          >
            {cancelLabel}
          </Button>
        )}
        {children}
      </PrimaryActions>
    </StyledActions>
  );
};
